export default "__VITE_ASSET__BIF8s1t6__"